import { PartialTranslation } from '../translations';

export const fr_FR: PartialTranslation = {
  newChat: 'Nouveau Chat',
  search: 'Rechercher',
  user: 'Utilisateur',
  settings: 'Paramètres',
  language: 'Langue',
  getHelp: 'Obtenir de l\'aide',
  viewAllPlans: 'Voir tous les plans',
  learnMore: 'En savoir plus',
  logOut: 'Se déconnecter',
  chooseLanguage: 'Choisir la Langue',
  chooseYourPreferredLanguage: 'Choisissez votre langue préférée',
  searchLanguages: 'Rechercher des langues...',
  autoDetect: 'Détection automatique',
  noLanguagesFound: 'Aucune langue trouvée',
  askAnything: 'Demandez n\'importe quoi',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personnel',
  freePlan: 'Plan gratuit',
  current: 'Actuel',
  close: 'Fermer',
  archive: 'Archiver',
  delete: 'Supprimer',
  confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce chat ?',
  confirmArchive: 'Êtes-vous sûr de vouloir archiver ce chat ?',
  deleteCannotUndo: 'Cette action ne peut pas être annulée.',
  archiveCanFind: 'Vous pouvez le trouver dans la liste d\'archives après l\'archivage.',

  // 归档标签页
  chats: 'Chats',
  archived: 'Archivé',
  restore: 'Restaurer',
  noArchivedChats: 'Aucun chat archivé',
  backToChats: 'Retour aux chats',

  // 资源面板
  resources: 'Ressources',
  addResource: 'Ajouter une ressource',
  deleteResource: 'Supprimer la ressource',
  noMatchingResourcesFound: 'Aucune ressource correspondante trouvée',
  noResourcesAvailable: 'Aucune ressource disponible',
  hideResources: 'Masquer les ressources',
  showResources: 'Afficher les ressources',

  // 聊天输入框
  typeMessage: 'Tapez un message...',
  thinkingOptions: 'Options de réflexion',
  deleteFile: 'Supprimer le fichier',
  clearSelection: 'Effacer la sélection',
  addAttachment: 'Ajouter une pièce jointe',
  sendMessage: 'Envoyer le message',

  // 思考模式选项
  deepInsight: 'Perspicacité Profonde · Analyse de Surface',
  deepInsightDesc: 'Compréhension rapide des points clés',
  deepExploration: 'Exploration Approfondie · Analyse Complète',
  deepExplorationDesc: 'Recherche approfondie multidimensionnelle',
  deepDeconstruction: 'Déconstruction Profonde · Argumentation Systématique',
  deepDeconstructionDesc: 'Analyse progressive couche par couche',

  // 写作模式选项
  contractReview: 'Révision de Contrat · Identification des Risques',
  contractReviewDesc: 'Analyse des clauses et vérification de conformité',
  textPolish: 'Polissage de Texte · Expression Professionnelle',
  textPolishDesc: 'Optimisation linguistique et ajustement structurel',
  legalDocuments: 'Documents Juridiques · Rédaction Standard',
  legalDocumentsDesc: 'Rédaction professionnelle de documents juridiques',

  // 认证和隐私翻译
  login: 'Connexion',
  register: 'S\'inscrire',
  welcomeBack: 'Bienvenue sur LawHelper',
  loginSubtitle: 'Votre Assistant IA de Recherche Juridique',
  continueWithGoogle: 'Continuer avec Google',
  continueWithMicrosoft: 'Continuer avec Microsoft',
  continueWithWeChat: 'Continuer avec WeChat',
  orContinueWith: 'ou continuer avec',
  emailTab: 'E-mail',
  phoneTab: 'Téléphone',
  emailPlaceholder: 'Entrez votre e-mail',
  phonePlaceholder: 'Entrez le numéro de téléphone',
  codePlaceholder: 'Entrez le code à 6 chiffres',
  sending: 'Envoi en cours...',
  verifying: 'Vérification...',
  verify: 'Vérifier',
  sendMagicLink: 'Envoyer le lien magique',
  getVerificationCode: 'Obtenir le code',
  resendCode: 'Renvoyer le code',
  resendIn: 'Renvoyer dans',
  magicLinkSent: 'Lien magique envoyé à votre e-mail',
  magicLinkHint: 'Nous enverrons un lien sécurisé à votre e-mail',
  otpSent: 'Code de vérification envoyé',
  agreeToTerms: 'En continuant, vous acceptez nos',
  privacyPolicy: 'Politique de confidentialité',
  termsOfService: 'Conditions d\'utilisation',
  and: 'et',
  privacyTitle: 'Votre vie privée compte',
  privacyIntro: 'Nous utilisons des cookies et des technologies similaires pour vous offrir la meilleure expérience. Vous pouvez personnaliser vos préférences ci-dessous.',
  essentialCookies: 'Cookies essentiels',
  essentialDesc: 'Nécessaires au fonctionnement du site',
  analyticsCookies: 'Cookies analytiques',
  analyticsDesc: 'Nous aident à améliorer notre service',
  marketingCookies: 'Cookies marketing',
  marketingDesc: 'Utilisés pour le contenu personnalisé',
  acceptAll: 'Tout accepter',
  essentialOnly: 'Essentiels uniquement',
  customize: 'Personnaliser',
  savePreferences: 'Enregistrer les préférences',
  back: 'Retour',
  readPrivacyPolicy: 'Lire notre politique de confidentialité',
  cookiePolicy: 'Politique des cookies',
  gdprCompliance: 'RGPD',
  piplCompliance: 'PIPL (Loi sur la protection des informations personnelles)',

  // AI工具面板
  aiReview: 'Révision IA',
  aiDraft: 'Rédaction IA',
  smartAssistant: 'Modèle',

  // 知识库搜索
  enableKnowledgeSearch: 'Activer la recherche',
  knowledgeSearchDesc: "L'IA recherche dans vos documents",
  clickToDisable: 'Désactiver',
  clickToEnable: 'Activer',

  // Landing page translations
  tagline: 'Intelligence juridique par IA',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplifié.',
  jurisdictionsLabel: 'Juridictions',
  accuracyLabel: 'Précision',
  fasterLabel: 'Plus rapide',
  availableLabel: 'Disponible',
  platformCapabilities: 'Fonctionnalités',
  testimonialQuote: '"LawHelper a transformé notre travail."',
  testimonialAuthor: 'Professionnel',
  testimonialPosition: 'Associé',
  viewPricing: 'Tarifs',
  footerPricing: 'Tarifs',
  footerPrivacy: 'Confidentialité',
  footerTerms: 'Conditions',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  closeResourcesPanel: 'Fermer le panneau de ressources',
  uploading: 'Téléchargement de %{fileName}...',
  processing: 'Traitement de %{fileName}...',
  uploadSuccess: '✓ %{fileName} téléchargé avec succès',
  uploadError: '✗ Échec du téléchargement : %{error}',
  quickAnswer: 'Réponse rapide',
  quickAnswerDesc: 'Réponse rapide aux questions simples',
  cancelRequest: 'Annuler',
  library: 'Bibliothèque',
  filterAll: 'Tout',
  filterChat: 'Discussions',
  filterReview: 'Révision',
  filterDraft: 'Brouillon',
  filterTemplate: 'Modèle',
  filterForm: 'Formulaire',
  thinking: 'Réflexion...',
  thinkingProcess: 'Processus de réflexion',
  analyzingLegalLogic: 'Analyse de la logique juridique...',
  lawhelperThinking: 'Lawhelper réfléchit...',
  serviceError: 'Erreur de service',
  uploaded: 'Téléchargé',
  settingsGeneral: 'Général',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Apparence',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Notifications de réponse',
  settingsResponseNotificationsDesc: 'Notification à la fin de la réponse IA',
  settingsColorMode: 'Mode couleur',
  settingsLight: 'Clair',
  settingsDark: 'Sombre',
  settingsSystem: 'Système',
  about: 'À propos',
  reviewTitle: 'Révision de document',
  exitReview: 'Quitter la révision',
  uploadPrompt: 'Télécharger un PDF pour commencer la révision',
  uploadButton: 'Sélectionner un fichier',
  startChatConfig: 'Tapez "Réviser ce document" pour commencer',
  reviewPlaceholder: 'Tapez un message ou "Réviser ce document"...',
  analyzing: 'Révision en cours...',
  reviewComplete: 'Révision terminée',
  issuesFound: '%{count} problèmes trouvés',
  draftTitle: 'Rédaction de document juridique',
  draftPlaceholder: 'Modifier ici ou demander à l\\\'IA de générer...',
  analyzingTemplate: 'Analyse du modèle %{name}...',
  templateAnalyzed: '✅ Modèle %{name} analysé ! Dites-moi comment le modifier.',
  templateAnalysisPrompt: 'Analyser les clauses clés du modèle',
  parsingFailed: '⚠️ Échec de l\\\'analyse du fichier, mais vous pouvez décrire vos besoins.',
  generating: 'Génération en cours...',
  generatedSuccess: '✅ Document généré ! Consultez et modifiez dans l\\\'éditeur.',
  drafterWelcome: 'Bienvenue dans l\\\'Assistant IA pour documents',
  drafterYouCan: 'Vous pouvez :',
  drafterUploadTemplate: 'Télécharger un modèle pour analyse IA',
  drafterDescribeNeeds: 'Décrire vos besoins documentaires',
  drafterLetAiHelp: 'L\\\'IA vous aide à rédiger contrats, accords, etc.',
  drafterExamples: 'Exemples :',
  drafterExampleRental: '"Rédigez un contrat de location"',
  drafterExampleLabor: '"Remplir le contrat de travail selon le modèle"',
  drafterInputPlaceholder: 'Décrivez vos besoins documentaires...',
  drafterThinking: 'Réflexion...',
  drafterHistoryTitle: 'Historique',
  drafterNoHistory: 'Aucun historique',
  drafterNewChat: 'Nouvelle discussion',
  drafterHistory: 'Historique',
  drafterRemoveAttachment: 'Supprimer la pièce jointe',
  drafterLineHeight: 'Interligne',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Exporter en Word (.docx)',
  drafterExportPdf: 'Exporter en PDF',
  drafterSave: 'Enregistrer le document',
  drafterDownload: 'Télécharger le document',
  drafterUndo: 'Annuler',
  drafterRedo: 'Rétablir',
  drafterBold: 'Gras',
  drafterItalic: 'Italique',
  drafterStrike: 'Barré',
  drafterUnderline: 'Souligné',
  drafterHighlight: 'Surligné',
  drafterLink: 'Insérer un lien',
  drafterAlignLeft: 'Aligner à gauche',
  drafterAlignCenter: 'Centrer',
  drafterAlignRight: 'Aligner à droite',
  drafterAlignJustify: 'Justifier',
  drafterList: 'Liste',
  drafterBulletList: 'Liste à puces',
  drafterOrderedList: 'Liste numérotée',
  drafterTaskList: 'Liste de tâches',
  drafterOpenResource: 'Ouvrir le panneau de ressources',
  drafterStopGeneration: 'Arrêter la génération',
  drafterAgentMode: 'Mode Agent actif | Cliquez pour passer au chat normal',
  drafterAgentModeOn: 'Mode Agent actif | Cliquez pour passer au chat normal',
  drafterAgentModeOff: 'Mode chat normal | Cliquez pour passer au mode Agent',
  drafterUploadAttachment: 'Télécharger une pièce jointe',
  drafterExit: 'Quitter',
  drafterConfirm: 'Confirmer',
  drafterOpenLink: 'Ouvrir le lien',
  drafterDeleteLink: 'Supprimer le lien',
  drafterQuote: 'Citation',
  workflowTitle: 'Workflow IA',
  workflowRunning: 'En cours...',
  workflowReady: 'Prêt',
  workflowCompleted: 'Terminé',
  workflowStartFailed: 'Échec du démarrage du workflow',
  workflowExecutionFailed: 'Échec de l\\\'exécution du workflow',
  workflowInterrupted: 'Workflow interrompu',
  workflowProcessing: 'Traitement...',
  workflowStepsCompleted: 'étapes terminées',
  workflowStepsTotal: 'Workflow terminé (%{count} étapes)',
  acceptChanges: 'Accepter les modifications',
  rejectChanges: 'Rejeter les modifications',
  changesAccepted: 'Modifications acceptées',
  changesRejected: 'Modifications rejetées',
  stopWorkflow: 'Arrêter',
  restartWorkflow: 'Redémarrer',
  startDrafting: 'Commencer la rédaction',
  interrupt: 'Arrêter',
  documentSubject: 'Sujet du document *',
  documentType: 'Type de document',
  jurisdiction: 'Juridiction',
  specialRequirements: 'Exigences spéciales (optionnel)',
  clickStartDrafting: 'Cliquez "Commencer la rédaction" pour démarrer le workflow',
  docTypeContract: 'Contrat',
  docTypeAgreement: 'Accord',
  docTypeNotice: 'Avis',
  docTypeLetter: 'Lettre',
  docTypePetition: 'Pétition',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Procuration',
  countryChina: 'Chine',
  countryUSA: 'États-Unis',
  countryGermany: 'Allemagne',
  countryJapan: 'Japon',
  countryFrance: 'France',
  countryUK: 'Royaume-Uni',
  citationVerified: 'Vérifié',
  citationUnverified: 'Non vérifié',
  imageLoadFailed: 'Échec du chargement de l\\\'image',
  smartDocTitle: 'Assistant document intelligent',
  smartDocChatTitle: 'Assistant IA pour documents',
  smartDocDropPrompt: 'Déposez un fichier PDF ici',
  smartDocSelectFile: 'Sélectionner un fichier',
  smartDocOr: 'ou',
  smartDocWelcomeTitle: 'Bienvenue dans l\\\'Assistant IA pour documents',
  smartDocWelcomeYouCan: 'Vous pouvez :',
  smartDocUploadForAI: 'Télécharger un modèle pour analyse IA',
  smartDocDescribeDoc: 'Décrire vos besoins documentaires',
  smartDocLetAIDraft: 'L\\\'IA vous aide à rédiger contrats, accords',
  smartDocExamples: 'Exemples :',
  smartDocExampleRental: '"Rédigez un contrat de location"',
  smartDocExampleLabor: '"Remplir le contrat de travail"',
  smartDocInputPlaceholder: 'Décrivez vos besoins documentaires...',
  smartDocRemoveAttachment: 'Supprimer la pièce jointe',
  smartDocOpenResources: 'Ouvrir le panneau de ressources',
  smartDocExit: 'Quitter',
  reviewStartFailed: 'Échec du démarrage du workflow de révision',
  reviewFailed: 'Révision échouée',
  reviewFoundIssues: 'Révision terminée, %{count} problèmes trouvés.',
  cannotReadStream: 'Impossible de lire le flux de réponse',
  parseEventFailed: 'Échec de l\\\'analyse de l\\\'événement',
  errorPrefix: 'Erreur',
  unknownError: 'Erreur inconnue',
  file: 'Fichier',
  loading: 'Chargement...',
  localFolders: 'Dossiers locaux',
  selectLocalFolder: 'Sélectionner un dossier local',
  reselectFolder: 'Changer de dossier',
  addToContext: 'Ajouter au chat',
  saveFile: 'Enregistrer',
  renameFile: 'Renommer',
  fileSaved: 'Fichier enregistré',
  fileRenamed: 'Fichier renommé en %{name}',
  browserNotSupported: 'Votre navigateur ne prend pas en charge l\\\'accès aux dossiers locaux',
  noFolderSelected: 'Sélectionnez un dossier local pour parcourir les fichiers',
  scanningFolder: 'Analyse du dossier...',
  selectFileToPreview: 'Sélectionnez un fichier pour aperçu',
  aiAnalyze: 'Analyse IA',
};
